// 对与用户相关的操作进行封装

import request from "@/utils/request.js";

/**
 * 用户登陆
 * @param {*} mobile 手机号
 * @param {*} code 验证码（密码）
 */
export const login = data => {
  return request({
    method: "POST",
    url: "/api/storeSubbranch/login",
    headers: {
      "Content-Type": "application/json"
    },
    // 参数: 根据接口文档，参数要通过body（请求体中）来传，对应到axios中，用data
    data: data
  });
};

/**
 * 重置密码
 * data={
	"code": "123456",
	"mobile": "18366666666",
	"userName": "LOKI",
	"weixinNum": "18366666666"
}
 * @param {*} mobile 手机号
 * @param {*} code 验证码
 * @param {*} userName 用户名
 * @param {*} weixinNum 微信号
 */
export const registered = data => {
  return request({
    method: "POST",
    url: "/api/member/registered",
    headers: {
      "Content-Type": "application/json"
    },
    // 参数: 根据接口文档，参数要通过body（请求体中）来传，对应到axios中，用data
    data: data
  });
};

/**
 * 重置密码
 * data={
	"code": "123456",
	"mobile": "18605042990",
	"password": "123456",
	"passwordRepeat": "123456"
}
 * @param {*} mobile 手机号
 * @param {*} code 验证码
 * @param {*} password 手机号
 * @param {*} passwordRepeat 验证码
 */
export const resetPassword = data => {
  return request({
    method: "POST",
    url: "/api/storeSubbranch/resetPassword",
    headers: {
      "Content-Type": "application/json"
    },
    // 参数: 根据接口文档，参数要通过body（请求体中）来传，对应到axios中，用data
    data: data
  });
};
/**
 * 重置密码
 * data={
	"code": "123456",
	"mobile": "18605042990",
}
 * @param {*} mobile 手机号
 * @param {*} code 验证码

 */
export const checkForgetPassword = data => {
  return request({
    method: "POST",
    url: "/mem/storeSubbranch/verificationCode",
    headers: {
      "Content-Type": "application/json"
    },
    // 参数: 根据接口文档，参数要通过body（请求体中）来传，对应到axios中，用data
    data: data
  });
};

/**
 * 校验图形验证码
 *  *@param {*} code 图形验证码
 */
export const verificationCode = code => {
  return request({
    method: "POST",
    url: "/mem/verificationCode/verificationCode?code=" + code,
    headers: {
      "Content-Type": "application/json"
    }
  });
};
/**
 * 发送验证码
 */
export const sendSmsCode = (mobile, type) => {
  if (type == null || type == undefined) {
    type = 0;
  }
  return request({
    method: "POST",
    url: "/api/verificationCode/sendSmsCod",
    headers: {
      "Content-Type": "application/json"
    },
    data: {
      mobile: mobile,
      type: type
    }
  });
};
